import type { ReactElement } from "react";
import type { UtilityConfidence } from "@shared/api";
import { confidenceShortLabel } from "./utilityInferenceLabels";
import styles from "./UtilityConfidencePill.module.css";

function pillTone(
  confidence: UtilityConfidence
): typeof styles.likely | typeof styles.unlikely | typeof styles.unknown {
  switch (confidence) {
    case "verified-available":
    case "likely-available":
      return styles.likely;
    case "likely-unavailable":
      return styles.unlikely;
    case "unknown":
      return styles.unknown;
    default: {
      const _exhaustive: never = confidence;
      return _exhaustive;
    }
  }
}

export interface UtilityConfidencePillProps {
  confidence: UtilityConfidence;
}

export function UtilityConfidencePill({
  confidence
}: UtilityConfidencePillProps): ReactElement {
  const text = confidenceShortLabel(confidence);
  return (
    <span className={`${styles.pill} ${pillTone(confidence)}`} title={text}>
      {text}
    </span>
  );
}
